import { Button, Modal } from 'src/components';
import { defineMessages, useIntl } from 'react-intl';
import { useCallback } from 'react';
import { ScenariosBetaApi } from 'src/api';
import useSafePush from 'src/hooks/useSafePush';
import { addToLocalStorageArrayEntry } from 'src/utils/webStorageArrayUtils';
import { WELCOME_TO_MEMRISE_STORAGE_KEY } from 'src/constants/storageKeys.const';
import { useUserContext } from 'src/context/user';
import * as S from './styles';

interface MigrationBannerModalProps {
  isOpen: boolean;
  onClose: () => void;
}
const msgs = defineMessages({
  header: { id: 'classic_ugc_move_confirmation' },
  description: { id: 'classic_ugc_move_confirmation_description' },
  buttonLabel: { id: 'classic_ugc_move_cta' },
});

export const MigrationBannerModal = ({ isOpen, onClose }: MigrationBannerModalProps) => {
  const intl = useIntl();
  const { safeReload } = useSafePush();
  const { user } = useUserContext();

  const onClick = useCallback(async () => {
    await ScenariosBetaApi.forceJoinScenariosBeta().then(_ => {
      addToLocalStorageArrayEntry(WELCOME_TO_MEMRISE_STORAGE_KEY, String(user?.id));
      onClose();
      safeReload();
    });
  }, [user?.id, onClose, safeReload]);

  return (
    <Modal isOpen={isOpen} hideCloseButton={false} darkCloseIcon handleClose={onClose}>
      <S.ModalContent>
        <S.ModalHeader>{intl.formatMessage(msgs.header)}</S.ModalHeader>
        <S.ModalDescription>{intl.formatMessage(msgs.description)}</S.ModalDescription>
        <Button buttonSize="medium" buttonType="primary" wide onClick={onClick}>
          {intl.formatMessage(msgs.buttonLabel)}
        </Button>
      </S.ModalContent>
    </Modal>
  );
};
